import * as React from 'react';
import { Box } from '../../../Box/Box.js';
import { useSolidTrack } from '../hooks/useTrack.js';

var SolidTrack = function SolidTrack(props) {
  var _props$progress = props.progress,
    progress = _props$progress === void 0 ? 100 : _props$progress;
  var _useSolidTrack = useSolidTrack(props),
    containerProps = _useSolidTrack.containerProps,
    trackProps = _useSolidTrack.trackProps,
    progressProps = _useSolidTrack.progressProps;
  return /*#__PURE__*/React.createElement(Box, containerProps, /*#__PURE__*/React.createElement(Box, trackProps), !!progress && /*#__PURE__*/React.createElement(Box, progressProps));
};
var SolidTrackMemoized = /*#__PURE__*/React.memo(SolidTrack);

export { SolidTrackMemoized as BaseSolidTrack, SolidTrackMemoized as SolidTrack };
//# sourceMappingURL=SolidTrack.js.map
